import { cityMap } from './Cities';
import standardSections from './Standard-City';

const sections = standardSections(
    "PlayDASHinDavis@gmail.com",
    "The hunt will begin at the courtyard on the south side of UC Davis, near the blue tile fountain. " +
    "We expect a walking distance of about 2-3 miles total throughout the day. " +
    "There are places to eat lunch along the route.");

cityMap['davis'].sections = sections;
cityMap['davis'].eventStartLocation = "The courtyard on the south side of UC Davis, near the blue tile fountain.";




// WEBPACK FOOTER //
// ./src/cities/Davis.js